"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyWithdrawal = applyWithdrawal;
exports.getWithdrawalInfo = getWithdrawalInfo;
exports.getWithdrawalStats = getWithdrawalStats;
exports.searchWithdrawal = searchWithdrawal;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function searchWithdrawal(data) {
  return (0, _request.default)({
    url: '/supplier/withdrawal/search',
    method: 'POST',
    data: data
  });
}
function getWithdrawalStats() {
  return (0, _request.default)({
    url: '/supplier/withdrawal/stats',
    method: 'GET'
  });
}
function applyWithdrawal(data) {
  return (0, _request.default)({
    url: '/supplier/withdrawal/save',
    method: 'POST',
    data: data
  });
}
function getWithdrawalInfo(id) {
  return (0, _request.default)({
    url: "/supplier/withdrawal/info/".concat(id),
    method: 'GET'
  });
}